export abstract class BasicConfigStructure {
  name: string;
  show: boolean;
  translation: string;
  limitNestedIteration = 2;

  protected constructor(attr: { name?: string, show?: boolean, translation?: string, limitNestedIteration?: number }) {
    this.name = attr.name;
    this.show = attr.show;
    if (attr.translation) {
      this.translation = attr.translation;
    } else {
      this.translation = "";
    }

    if (attr.limitNestedIteration) {
      this.limitNestedIteration = attr.limitNestedIteration;
    }
  }

  protected safeAction(call: Function, err?: Function) {
    try {
      call.call(this);
    } catch (e) {
      if (err) {
        err.call(this);
      }
    }
  }
}
